import { render } from "./Library.vue?vue&type=template&id=4b54ae38&ts=true"
import script from "./Library.vue?vue&type=script&lang=ts"
export * from "./Library.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__